export const GET_NOTIFICATION_THRU_WS = 'V3_GET_NOTIFICATION_THRU_WS'
export const CLEAR_NOTIFICATIONS = 'V3_CLEAR_NOTIFICATIONS'